import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import SearchProvider from 'components/search/search.context';
import { useACHTransactionsSearchParams } from './money-movement-transactions.hooks';
import MoneyMovementTransactionsDataGrid from './money-movement-transactions-data-grid/money-movement-transactions-data-grid.component';

const MoneyMovementTransactions = () => {
  return (
    <SearchProvider value={useACHTransactionsSearchParams()}>
      <SearchToolbar />
      <MoneyMovementTransactionsDataGrid />
    </SearchProvider>
  );
};

export default MoneyMovementTransactions;
